import { render, staticRenderFns } from "./AnnouncementBox.vue?vue&type=template&id=fddd6214&scoped=true&"
import script from "./AnnouncementBox.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementBox.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementBox.vue?vue&type=style&index=0&id=fddd6214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddd6214",
  null
  
)

export default component.exports